import { useTranslation } from "react-i18next"
import { OrderDetailModalActionStyle } from "overrides/theme/entel/base/pages/DetailOrderScreens/styles/OrderDetailModalAction.style"
import translatesObj from "overrides/theme/entel/base/translates/translation.json"
import { useParams } from "react-router-dom"
import get_cancel_reasons from "overrides/theme/entel/base/helpers/cancel_reasons"
import { FormCancelAction, FormRescheduleAction } from "overrides/theme/entel/base/components/OrderDetail/ModalActions"

const OrderDetailModalAction = ({
  action,
  status,
  confirmAction,
  close,
  set_reason_cancel,
  items_selialized_completed,
  data,
  reschedule_data,
}: any) => {
  const { t } = useTranslation()
  const isCancel = action.action === "cancel"
  const isReschedule = action.action === "reschedule"
  const isPick = action.action === "pick"
  const _translates: any = translatesObj
  const { shippingtype }: any = useParams()
  const cancel_reasons = get_cancel_reasons(status, shippingtype)

  return (
    <>
      <div className="order_detail_modal_action__root">
        <div className="order_detail_modal_action__main_cont">
          <div className="order_detail_modal_action__cont_title">
            <p className="order_detail_modal_action__cont_title_main">
              ¿Desea aplicar{" "}
              <span>
                "
                {status === "IN_TRANSIT" && action.action === "cancel"
                  ? "Retornar y cancelar"
                  : t(_translates[action.action])}
                "
              </span>{" "}
              a esta orden?
            </p>
            <p className="order_detail_modal_action__cont_title_descr">Esta acción NO se puede deshacer</p>
          </div>
          <div className="order_detail_modal_action__cont_body">
            {isCancel && (
              <FormCancelAction
                action={action}
                close={close}
                confirmAction={confirmAction}
                cancel_reasons={cancel_reasons}
                set_reason_cancel={set_reason_cancel}
                status={status}
              />
            )}
            {isReschedule && (
              <FormRescheduleAction
                close={close}
                confirmAction={confirmAction}
                data={data}
                reschedule_data={reschedule_data}
              />
            )}
          </div>
          {!isCancel && !isReschedule && (
            <div className="order_detail_modal_action__cont_buttons">
              <button className="order_detail_modal_action__btn_no" onClick={close}>
                No
              </button>
              <button
                disabled={Boolean(isPick ? !items_selialized_completed : false)}
                className="order_detail_modal_action__btn_yes"
                onClick={() => {
                  confirmAction()
                  close()
                }}
              >
                {`Si, aplicar ${t(_translates[action.action])}`}
              </button>
            </div>
          )}
        </div>
      </div>
      <style jsx>{OrderDetailModalActionStyle}</style>
    </>
  )
}

export default OrderDetailModalAction
